import {provideAppInitializer, inject, EnvironmentProviders, Injector} from '@angular/core';
import { eLayoutType, ReplaceableComponentsService } from '@abp/ng.core';
import { ApplicationLayoutComponent } from '../layouts/application/application-layout.component';
import { AccountLayoutComponent } from '../layouts/account/account-layout.component';
import { EmptyLayoutComponent } from '../layouts/empty/empty-layout.component';
import { eThemeBasicComponents } from '../models/components';

export const BASIC_THEME_LAYOUT_PROVIDERS = [
  provideAppInitializer(() => {
    const initializerFn = configureLayouts(inject(ReplaceableComponentsService));
    return initializerFn();
  }),
];

export function configureLayouts(replaceableComponents: ReplaceableComponentsService) {
  return () => {
    replaceableComponents.add({
      key: eThemeBasicComponents.ApplicationLayout,
      component: ApplicationLayoutComponent,
    });
    replaceableComponents.add({
      key: eThemeBasicComponents.AccountLayout,
      component: AccountLayoutComponent,
    });
    replaceableComponents.add({
      key: eThemeBasicComponents.EmptyLayout,
      component: EmptyLayoutComponent,
    });

    // Map the layout types to the theme components
    replaceableComponents.add({
      key: eLayoutType.application,
      component: ApplicationLayoutComponent,
    });
    replaceableComponents.add({
      key: eLayoutType.account,
      component: AccountLayoutComponent,
    });
    replaceableComponents.add({
      key: eLayoutType.empty,
      component: EmptyLayoutComponent,
    });
  };
}
